import { createSlice } from "@reduxjs/toolkit";

const apiDataSlice = createSlice({
  name: "apiData",
  initialState: {
    response: null,
  },
  reducers: {
    addApiData: (state, action) => {
        state.response = action.payload;
      },
  },
});

export const {addApiData} = apiDataSlice.actions;
export default apiDataSlice.reducer;
